import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUserMappedFeature } from "../dashboard-features/featuresApiS";

export const checkPathAccess = createAsyncThunk(
  "features/checkPathAccess",
  async ({ userId, token, path }, { rejectWithValue }) => {
    try {
      const response = await fetchUserMappedFeature({ user_id: userId }, token);

      if (response.error) {
        return rejectWithValue(response.error);
      }

      const isPathAuthorized = response?.data
        ?.flatMap((menu) => menu.sub_menu || [])
        .some((feature) => feature.path === path);

      return isPathAuthorized;
    } catch (error) {
      return rejectWithValue(error.message || "An error occurred");
    }
  }
);

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState: {
    isOpen: false,

    isPathAuthorized: null,
    loading: false,
    error: null,
  },
  reducers: {
    toggleSideBar: (state, action) => {
      state.isOpen = action.payload;
    },
    resetPathAccess(state) {
      state.isPathAuthorized = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(checkPathAccess.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(checkPathAccess.fulfilled, (state, action) => {
        state.isPathAuthorized = action.payload;
        state.loading = false;
      })
      .addCase(checkPathAccess.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
        state.isPathAuthorized = false;
      });
  },
});

export const { toggleSideBar, resetPathAccess } = sidebarSlice.actions;
export const sidebarSelector = (state) => state.sidebar?.isOpen;
export default sidebarSlice.reducer;
